/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Breadcrumb_HomeInputs */

const en_pc_breadcrumb_home = /** @type {(inputs: Pc_Breadcrumb_HomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Home`)
};

const zh_pc_breadcrumb_home = /** @type {(inputs: Pc_Breadcrumb_HomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`首页`)
};

/**
* | output |
* | --- |
* | "Home" |
*
* @param {Pc_Breadcrumb_HomeInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_breadcrumb_home = /** @type {((inputs?: Pc_Breadcrumb_HomeInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Breadcrumb_HomeInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_breadcrumb_home(inputs)
	return zh_pc_breadcrumb_home(inputs)
});
export { pc_breadcrumb_home as "pc.breadcrumb.home" }